export default __webpack_public_path__ + "static/media/tempestofset.e824c34e.png";